import {Service} from "../../../@types/pricingTablePaymentServiceResources.tsx";
import {Trans, useTranslation} from "react-i18next";
import {buildRateString} from "../../../helpers/pricing/calculatorHelper.ts";
import {Plus} from "lucide-react";
import {HashLink} from "react-router-hash-link";

const DesktopPricingTableSection = ({service, index}: {service: Service, index: number}) => {

    const {t} = useTranslation();

    return (
        <>
            <tr>
                <td className="pricing-table-heading-desktop fw-semibold fs-7 pt-3 pb-3">
                    <HashLink to={`/${t('routes.payment_methods') + '#' + service.heading}`}>
                        <Trans t={t}>
                            {t(service.heading)}
                        </Trans>
                    </HashLink>
                </td>
                <td></td>
                <td></td>
                <td></td>
                {index === 0
                    ? <td className="bg-gray text-center align-middle fs-3 text-muted rowspan" rowSpan={14}>
                        <Plus />
                </td>
                    : null}
                <td></td>
            </tr>
            {service.countries.map((country, index) => (
                <tr key={index}>
                    <td className="d-flex align-items-center pb-2 gap-2">
                        {country.flag.map((flag, index) => (
                            <div key={index} className="d-flex align-items-center">
                                <img className="me-2" src={flag} alt='country flag icon'/>
                                <div className="pt-1">{t(country.name[index])}</div>
                            </div>
                        ))}
                    </td>
                    <td className="text-center">{country.percentageRate} %</td>
                    <td className="text-center">
                        {buildRateString(country.minRate)}
                    </td>
                    <td className="text-center">
                        {buildRateString(country.maxRate)}
                    </td>
                    <td className="text-center">{buildRateString(country.fixedRate)}</td>
                </tr>
            ))}
        </>
    )
}

export default DesktopPricingTableSection;
